import { appModules } from '../services/licence.service';
import { companyAdminRoles } from '../utility/role';
import { MenuSubItem } from './menu-subitem.model';
import { MenuItem } from './menu.item.model';

export const users: MenuSubItem[] = [
  {
    icon: 'people',
    route: '/schedule',
    name: 'nav.schedule',
    module: appModules.users,
  },
  {
    icon: 'people',
    route: '/users',
    name: 'nav.userManagement',
    roles: companyAdminRoles,
  },
];

export const extras: MenuSubItem[] = [
  {
    icon: 'cog',
    route: '/templates',
    name: 'nav.templates',
    module: appModules.essentials,
  },
  {
    icon: 'cog',
    route: '/options',
    name: 'nav.options',
    roles: companyAdminRoles,
    module: appModules.users,
  },
];

export const items: MenuItem[] = [
  {
    icon: 'home',
    name: 'nav.home',
    route: '/home',
  },
  {
    icon: 'business',
    name: 'nav.sites',
    route: '/worker/sites',
  },
  {
    icon: 'document',
    name: 'sites.tickets',
    route: '/worker/tickets',
  },
  {
    icon: 'people',
    name: 'nav.personel',
    children: users,
  },
];

export const adminMenu = {
  items,
};
